module.exports = __webpack_public_path__ + "img/aztec_600.da55cf45.png";